// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import authReducer from "./reducers/auth";
import beefBodyReducer from "./reducers/beef_bodies";
import { Provider } from "react-redux";
import { combineReducers, createStore } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import customerReducer from "./reducers/customer";
import originReducer from "./reducers/origin";

const root = ReactDOM.createRoot(document.getElementById("root"));
const rootReducer = combineReducers({
  auth: authReducer,
  beefBody: beefBodyReducer,
});
const store = configureStore({
  reducer: {
    auth: authReducer,
    beefBody: beefBodyReducer,
    customers: customerReducer,
    origins: originReducer,
  },
}); //tes
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
